// Mock data for Forsyt website

export const testimonials = [
  {
    id: 1,
    quote: "I like the concept and actions. The core thought is right, the dashboard should show pipeline health based on stages and the actions depending on them.",
    author: "Anindita",
    role: "CRO",
    company: "",
    image: "/assets/avatar-women-32.jpg",
    companyLogo: "",
    videoThumb: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800&h=600&fit=crop",
    cta: "See the Dashboard"
  },
  {
    id: 2,
    quote: "This is what was needed, it will definitely help the sales team. We are looking forward to seeing a demo to evaluate how helpful it is for us.",
    author: "Sandeep",
    role: "CRO",
    company: "",
    image: "/assets/avatar-men-45.jpg",
    companyLogo: "",
    videoThumb: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&h=600&fit=crop",
    cta: "Book a Demo"
  },
  {
    id: 3,
    quote: "Our main interest is if we can find the right insights on what to sell based on history and patterns. We want to do a pilot to see how this gets more revenue.",
    author: "Shikhar",
    role: "CRO",
    company: "",
    image: "/assets/avatar-men-22.jpg",
    companyLogo: "",
    videoThumb: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&h=600&fit=crop",
    cta: "Start a Pilot"
  },
  {
    id: 4,
    quote: "We are ready for trying out the MVP. We want to see if we can add value to our team, especially since our organization is more offline sales based.",
    author: "Gautham",
    role: "Core Leader",
    company: "",
    image: "/assets/avatar-men-67.jpg",
    companyLogo: "",
    videoThumb: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&h=600&fit=crop",
    cta: "Try the MVP"
  }
];

export const companyLogos = [
  { name: "Team 1", id: 1, image: "/assets/1qcpjjfa.webp" },
  { name: "Team 2", id: 2, image: "/assets/cpa6j1us.webp" },
  { name: "Team 3", id: 3, image: "/assets/0mebycjh.webp" },
  { name: "Team 4", id: 4, image: "/assets/5z3rjwd7.webp" },
  { name: "Team 5", id: 5, image: "/assets/68adifry.webp" },
  { name: "Team 6", id: 6, image: "/assets/vx5o7k6j.webp" },
  { name: "Team 7", id: 7, image: "/assets/jf9prxhl.webp" },
  { name: "Team 8", id: 8, image: "/assets/yl8rdh5p.webp" },
  { name: "Team 9", id: 9, image: "/assets/z2k0pwv4.webp" },
  { name: "Team 10", id: 10, image: "/assets/h0wn8zp9.webp" },
  { name: "Team 11", id: 11, image: "/assets/owel2gpp.webp" },
  { name: "Team 12", id: 12, image: "/assets/9ezty85h.webp" },
  { name: "Team 13", id: 13, image: "/assets/1m2eaq4g.webp" },
  { name: "Team 14", id: 14, image: "/assets/hxk9p7ig.webp" },
  { name: "Team 15", id: 15, image: "/assets/1fnoyb4a.webp" }
];

export const agentFeatures = [
  {
    id: 'sales-executive',
    title: 'Sales Executive',
    description: 'Free your AEs from CRM jail. Whether your team uses Salesforce, Zoho, or LeadSquared, Forsyt captures actions without the need for a standalone notetaker. It pushes one-click follow-ups and next actions directly into their flow so they spend more time selling.',
    features: [
      { icon: 'CheckCircle', title: 'Automated CRM Syncing', desc: 'Works seamlessly with your existing stack, including Salesforce and Zoho, to keep fields updated without manual entry.' },
      { icon: 'FileText', title: 'Action-Driven Workflows', desc: 'Stop guessing what to do next. Forsyt surfaces the exact actions needed depending on the current stage of the deal.' },
      { icon: 'Mail', title: 'Built for Online & Offline Sales', desc: 'Flexible enough to add value to traditional inside sales teams as well as organizations with heavy offline and field sales motions.' }
    ],
    testimonial: {
      quote: "This is what was needed, it will definitely help the sales team. I'm looking forward to a demo to share with my team.",
      author: "Sandeep",
      role: "CRO",
      company: "",
      image: "/assets/avatar-men-45.jpg"
    }
  },
  {
    id: 'revenue-leader',
    title: 'Revenue Leader',
    description: 'CROs use Forsyt as a real-time brief on pipeline health and team execution. Demand accurate forecasting and ensure your reps are running the right plays to protect and grow your PnL.',
    features: [
      { icon: 'TrendingUp', title: 'Stage-Based Pipeline Health', desc: 'Get a clear view of your pipeline health based strictly on deal stages and the specific actions being executed on them.' },
      { icon: 'PieChart', title: 'Historical Pattern Intelligence', desc: 'Find the right insights on what to sell to your market based on historical data and buying patterns to maximize revenue.' },
      { icon: 'Users', title: 'Seamless MVP & Sandbox Testing', desc: 'Evaluate value quickly. We offer dedicated sandboxes and structured MVP pilots so your team can test the impact before a full rollout.' }
    ],
    testimonial: {
      quote: "I like the concept and actions. The core thought is right, and I am open to looking at the MVP once it is live.",
      author: "Anindita",
      role: "CRO",
      company: "",
      image: "/assets/avatar-women-32.jpg"
    }
  },
  {
    id: 'account-management',
    title: 'Account Management & Expansion',
    description: 'Turn your account managers into revenue generators. Forsyt uncovers historical buying patterns and routes tailored product recommendations to your reps so they know exactly what to pitch to existing accounts.',
    features: [
      { icon: 'AlertTriangle', title: 'Cross-Sell Pattern Matching', desc: 'Analyze account history to find the right insights on what additional products to sell to existing clients.' },
      { icon: 'BarChart3', title: 'PnL Growth Tracking', desc: 'Tie specific account actions directly to revenue outcomes, helping leaders who are responsible for PnL prove the ROI of their team.' },
      { icon: 'FileText', title: 'Offline Network Support', desc: 'Equip reps who sell to shopkeepers or operate in offline environments with the same powerful insights as digital sellers.' }
    ],
    testimonial: {
      quote: "We want this for our people who sell to shopkeepers. If we can find the right insights on what to sell based on history and patterns, it actually gets more revenue for them.",
      author: "Shikhar",
      role: "CRO",
      company: "",
      image: "/assets/avatar-men-22.jpg"
    }
  }
];

export const stats = [
  { value: '2.5 hours/day', label: 'Average seller time reclaimed from tool‑hopping and manual updates' },
  { value: '5 MVPs live', label: 'Production‑grade deployments with 5,000+ signups in the near‑term pipeline' },
  { value: '30, 50%', label: 'Reduction in manual forecast interrogation time for CROs and RevOps leaders' }
];
